import { DEFAULT_FRACTION_DIGITS } from "@/constants";

export const getNumberFormatter =
  (language: string) =>
  (value: string | number | undefined | null): string => {
    if (value === "" || value === null) return "";

    const num = typeof value === "string" ? parseFloat(value) : value;
    if (typeof num === "undefined" || isNaN(num)) return "";

    return num.toLocaleString(language, {
      minimumFractionDigits: DEFAULT_FRACTION_DIGITS,
      maximumFractionDigits: DEFAULT_FRACTION_DIGITS,
    });
  };
